import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    description: {
      backgroundColor: theme.palette.common.gray100,
      display: 'flex',
      gap: theme.spacing(2),
      flexDirection: 'column',
      padding: theme.spacing(2),
      borderRadius: theme.misc.borderRadius,
    },
    noticeText: {
      color: '#888888',
      fontSize: '14px',
      '& a:link': {
        color: '#888888',
      },
    },
    columnLayout: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    requiredLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    reachDesktopBorder: {
      [theme.breakpoints.up('md')]: {
        borderRadius: '15px',
        boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2.30916px 4.61832px',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
      },
    },
    desktopBorder: {
      [theme.breakpoints.up('md')]: {
        borderRadius: theme.misc.borderRadius,
        border: theme.customBorders.gray300,
        padding: theme.spacing(3),
      },
    },
    applyWrapper: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      padding: theme.spacing(2),
      paddingTop: theme.spacing(1),
      borderTop: `1px solid ${theme.palette.common.gray200}`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(1),
      background: theme.palette.common.white,
      zIndex: 1,
      [theme.breakpoints.up('md')]: {
        width: '680px',
        left: 'calc(50% - 340px)',
      },
    },
    button: {
      width: '100%',
      borderRadius: '20px',
    },
    applyText: {
      color: theme.palette.common.gray600,
    },
    title: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
    icon: {
      color: theme.palette.common.gray800,
    },
    desktopSmallerButton: {
      [theme.breakpoints.up('md')]: {
        alignSelf: 'flex-start',
      },
    },
    referrerNotice: {
      padding: theme.spacing(1.5),
      paddingRight: theme.spacing(2),
      lineHeight: '150%',
      display: 'flex',
      alignItems: 'center',
      background: '#FAFFDC',
      borderRadius: '6px',
      gap: theme.spacing(1),
    },
  }),
);
